import { motion } from "framer-motion";
import { Ticket, Sparkles, Trophy, Clock } from "lucide-react";
import { Reveal } from "@/components/landing/primitives";

export default function LotterySection() {
  return (
    <section id="lottery" className="relative py-20 md:py-28 scroll-mt-24" data-testid="section-lottery">
      <div className="container-trt">
        <Reveal>
          <div className="relative rounded-3xl overflow-hidden glass-gold p-8 md:p-14">
            <div className="absolute inset-0 grid-lines opacity-30" />
            <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-[radial-gradient(circle,rgba(244,201,93,0.25),transparent_60%)] blur-2xl" />

            <div className="relative z-10 grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <span className="eyebrow flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" /> Lottery & Lucky Draw</span>
                <h2 className="font-display text-3xl md:text-5xl font-extrabold mt-4 leading-tight">
                  Stake, play &<br /><span className="gold-text text-glow">win big rewards</span>
                </h2>
                <p className="mt-4 text-[var(--muted)] max-w-md leading-relaxed">
                  Every stake earns lottery entries. Provably-fair, on-chain draws distribute jackpot rewards to lucky holders — automatically, transparently, and verifiably.
                </p>
                <div className="mt-8 flex flex-wrap gap-4">
                  <a href="#staking" className="btn-gold"><Ticket className="w-4 h-4" /> Get Entries</a>
                  <div className="flex items-center gap-2 text-sm font-mono text-[var(--muted)]">
                    <Clock className="w-4 h-4 text-[var(--gold-2)]" /> Next draw in 2d 14h
                  </div>
                </div>
              </div>

              {/* Jackpot card */}
              <div className="relative">
                <motion.div
                  animate={{ y: [0, -10, 0] }}
                  transition={{ duration: 4, repeat: Infinity }}
                  className="glass rounded-3xl p-8 text-center gold-glow"
                  data-testid="lottery-jackpot"
                >
                  <Trophy className="w-10 h-10 text-[var(--gold-2)] mx-auto" />
                  <div className="mt-4 text-xs font-mono uppercase tracking-widest text-[var(--muted)]">Current Jackpot</div>
                  <div className="mt-2 font-display text-4xl md:text-5xl font-extrabold gold-text">250,000</div>
                  <div className="text-sm font-mono text-[var(--muted)]">TRT</div>
                  <div className="mt-6 grid grid-cols-3 gap-3">
                    {[["Entries", "48.2K"], ["Winners", "25"], ["Odds", "Fair"]].map(([l, v]) => (
                      <div key={l} className="glass rounded-xl py-3">
                        <div className="font-display font-bold text-[var(--gold-2)]">{v}</div>
                        <div className="text-[10px] font-mono text-[var(--muted)] uppercase">{l}</div>
                      </div>
                    ))}
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
